module.exports = __webpack_public_path__ + "img/login_background_new.fb7d6c18.jpeg";